export default angular
  .module("AddCodeAliasCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("AddCodeAliasController", [
    "$scope",
    "codeAliasData",
    "$modalInstance",
    "$modal",
    "$rootScope",
    "Scripts",
    "System",
    "Aliases",
    function (
      $scope,
      codeAliasData,
      $modalInstance,
      $modal,
      $rootScope,
      Scripts,
      System,
      Aliases,
    ) {
      $scope.sortResources = {};
      $scope.sortResources.column = "NAME";
      $scope.sortResources.direction = false;
      $rootScope.aliasPageCount = $rootScope.aliasPageCount || 1

      const filterAliasFields = aliases =>
        aliases.map(({
          NAME, ALIAS_GROUP, TIME_STAMP, SYS_ID, SYSTEM_USERS,
        }) => ({
          NAME, GROUP_NAME: decodeGroupDescription(ALIAS_GROUP), TIME_STAMP, SYS_ID, EDITOR: SYSTEM_USERS && SYSTEM_USERS.USER_FULL_NAME || '',
        }));

      const decodeGroupDescription = (groupId) => {
        switch (groupId) {
          case 1: return "Diagnosis";
          case 3: return "Drug";
          case 5: return "Result";
          case 11: return "Procedure";
          case 13: return "Risk";
          case 14: return "Vaccination";
          default: return "";
        }
      };
      const setPage = (page) => {
        $scope.currentPage = page;
        $rootScope.aliasListPage = page;
        const newVal = $scope.searchString;
        if (!Aliases.loading.aliases) {
          const filter = newVal ? `&filter=${newVal}` : ``
          System.loadAllCodesAliases(`aliases?offset=${(page - 1) * 10}${filter}`, (aliases) => {
            $scope.availableAliases = filterAliasFields(aliases.rows);
            $rootScope.aliasPageCount = aliases.count;
          });

        }
      };
      $scope.pageChanged = setPage;

      $scope.$watch(
        "searchString",
        (newVal) => {
          const filter = newVal ? `?filter=${newVal}` : ``
          System.loadAllCodesAliases(`aliases${filter}`, (aliases) => {
            $scope.availableAliases = filterAliasFields(aliases.rows);
            $rootScope.aliasPageCount = aliases.count;
          });
        },
        true,
      );

      $scope.addCodeAlias = function (selectedAlias) {
        selectedAlias.SCRIPT_ID = $rootScope.pageID;
        Scripts.addCodeAlias(selectedAlias, () => {
          $modalInstance.close();
        });
      };

      $scope.addNewCodeAlias = function (aliasName) {
        const selectedAlias = {};
        selectedAlias.ALIAS_NAME = aliasName;
        selectedAlias.SCRIPT_ID = $rootScope.pageID;
        System.saveNewCodeAlias(selectedAlias, () => {
          System.loadAllCodesAliases(`aliases?filter=${scope.searchString}`, (alias) => {
            $scope.availableAliases = filterAliasFields(alias.rows);
            $rootScope.aliasPageCount = alias.count;
          });
        });
      };

      $scope.changeSorting = function (column) {
        if ($scope.sortResources.column == column) {
          $scope.sortResources.direction = !$scope.sortResources.direction;
        } else {
          $scope.sortResources.column = column;
          $scope.sortResources.direction = false;
        }
      };

      $scope.ok = function () {
        $modalInstance.close();
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
    },
  ]);
